import axios from 'axios';
import moment from 'moment';
import { getErrorMessage } from '../util/ErrorUtils';

export const releaseReportFromHoldQueueAPI = async (reportId) => {
    return await axios.get(`/api/v1/groupadmin/release-report-from-hold-queue`, {
        params: { reportId },
    })
        .then(function (response) {
            return { success: !!response.data };
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}


export const fetchWorklistAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1,
        "skippedVisits": [
            0
        ],
    };

    return await axios.post(`/api/v1/groupadmin/worklist-visits`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data }
            }
        }).catch(function (error) {
            return { success: false, error }
        })
}


export const fetchParkedVisitsAPI = async (payload) => {

    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.get(`/api/v1/groupadmin/parked-visits`, {
        params: {
            page: data.page,
            size: data.size
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data }
            }
        }).catch(function (error) {
            return { success: false, error }
        })
}

export const fetchSFVVisitsAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.get(`/api/v1/groupadmin/submitted-for-verification-visits`, {
        params: {
            page: data.page,
            size: data.size
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data }
        }
    }).catch(function (error) {
        return { success: false, error }
    })
}

export const fetchSubmittedToTypistVisitsAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.get(`/api/v1/groupadmin/submitted-to-typist-visits`, {
        params: {
            page: data.page,
            size: data.size
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data }
        }
    }).catch(function (error) {
        return { success: false, error }
    })
}

export const fetchLockedVisitsAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1
    };
    return await axios.get(`/api/v1/groupadmin/locked-visits`, {
        params: {
            page: data.page,
            size: data.size
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data }
        }
    }).catch(function (error) {
        return { success: false, error }
    })
}

export const getVisitReportAPI = async (risId, reportId, visitNo) => {

    return await axios.get(`/api/v1/groupadmin/visit-report`, {
        params: {
            risId,
            reportId,
            visitNo
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, visitReport: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const updateStudyAPI = async (payload) => {

    const data = {
        "priority": payload.priority,
        "reportId": payload.reportId
    };

    return await axios.post(`/api/v1/update-study`, data)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data }
            }
        }).catch(function (error) {
            return { success: false, error }
        })
}

export const unparkVisitAPI = async (orderNo) => {
    return await axios.post(`/api/v1/unpark-visit`, { orderNo })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false, error: null };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}